export default __webpack_public_path__ + "static/media/504.cd5cfb52.jpg";